<template>
  <div class="attachment-list">
    <el-tag
      v-for="attachment in attachments"
      :key="attachment.id"
      effect="dark"
      type="info"
      size="small"
      class="mr-1"
      @click="downloadFile(attachment)"
    >
      <i :class="isLoading ? 'el-icon-loading' : fileTypeIcon(getFileExtension(attachment.path))" />
      {{ attachment.path }}
    </el-tag>
  </div>
</template>
<script lang="ts">

import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { GetTicketAttachmentUrlQuery, TicketAttachment } from '@/types/graphql'

@Component({
  components: {
  }
})
export default class extends Vue {
    @Prop({ required: true }) private attachments!: TicketAttachment[]

    private isLoading=false;

    downloadFile(attachment: TicketAttachment) {
      this.isLoading = true
      this.$apollo.query({
        query: GetTicketAttachmentUrlQuery,
        variables: {
          attachmentID: attachment.id,
          fileName: attachment.path
        }
      }).then(res => {
        window.open(res.data.getTicketAttachmentURL, '_blank')
      }).finally(() => {
        this.isLoading = false
      })
    }

    private getFileExtension(fileName: any) {
      return fileName.split('.').pop()
    }

    private fileTypeIcon(extension: string) {
      switch (extension.toLowerCase()) {
        case 'jpg': return 'el-icon-picture'
        case 'png': return 'el-icon-picture'
        case 'ico': return 'el-icon-picture'
        case 'gif': return 'el-icon-picture'
        case 'bmp': return 'el-icon-picture'
        default: return 'el-icon-document'
      }
    }
}
</script>

<style scoped>

.attachment-list .el-tag{
  cursor: pointer;
}

</style>
